import React, { useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import {
    LuBell, LuMenu,
    LuUserRound, LuStore, LuChevronDown,
    LuUser, LuLogOut, LuSettings
} from "react-icons/lu";
import { useDispatch, useSelector } from 'react-redux';
import { setActiveBusiness, setSelectedBusiness } from '../redux/reducers/businessSlice';
import { useNavigate } from 'react-router-dom';
import { logout } from '../redux/reducers/authSlice';
import ConfirmModal from './ConfirmModal';

const Header = ({ toggleSidebar }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [showLogoutModal, setShowLogoutModal] = useState(false);

    const { userDetail } = useSelector((state) => state.auth);
    const { businessList, selectedBusiness, activeBusinessId } = useSelector((state) => state.business);

    const handleBusinessSwitch = (biz) => {
        dispatch(setSelectedBusiness(biz));
        dispatch(setActiveBusiness(biz._id));
        // We don't necessarily need a window.location.reload() if our components are reactive
        // but the booking system use it, we can too if needed for consistency.
        // window.location.reload(); 
    };

    const handleLogout = () => {
        setShowLogoutModal(true);
    };

    const confirmLogout = () => {
        dispatch(logout());
        navigate("/login");
    };

    return (
        <header className="main-header sticky-top bg-white border-bottom d-flex align-items-center justify-content-between px-3" style={{ height: '70px' }}>

            <div className="d-flex align-items-center gap-2">
                <div className="p-2 rounded hover-effect cursor-pointer d-md-none" onClick={toggleSidebar}>
                    <LuMenu size={24} />
                </div>

                {/* BUSINESS SWITCHER - PILL STYLE */}
                {businessList && businessList.length > 0 ? (
                    <Dropdown align="start">
                        <Dropdown.Toggle as="div" className="d-flex align-items-center gap-2 cursor-pointer no-caret border rounded-pill px-3 py-1 bg-light shadow-sm">
                            <LuStore size={16} className="text-brand" />
                            <div className="text-start">
                                <p className="mb-0 fw-bold lh-1 text-truncate" style={{ fontSize: '12px', maxWidth: '140px' }}>
                                    {selectedBusiness?.name || "Select Business"}
                                </p>
                            </div>
                            <LuChevronDown size={14} className="text-muted" />
                        </Dropdown.Toggle>

                        <Dropdown.Menu className="border-0 shadow mt-2" style={{ borderRadius: '12px', minWidth: '240px' }}>
                            <div className="px-3 py-2 border-bottom">
                                <small className="text-muted fw-bold text-uppercase" style={{ fontSize: '10px' }}>
                                    Your Businesses ({businessList.length})
                                </small>
                            </div>

                            <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                                {businessList.map((biz) => (
                                    <Dropdown.Item
                                        key={biz._id}
                                        onClick={() => handleBusinessSwitch(biz)}
                                        className={`py-2 d-flex align-items-center gap-3 ${selectedBusiness?._id === biz._id ? 'bg-light' : ''}`}
                                    >
                                        <div className={`p-2 rounded ${selectedBusiness?._id === biz._id ? 'bg-brand text-white' : 'bg-soft-brand text-brand'}`}>
                                            <LuStore size={14} />
                                        </div>
                                        <div className="flex-grow-1">
                                            <p className={`mb-0 small ${selectedBusiness?._id === biz._id ? 'fw-bold text-brand' : ''}`}>
                                                {biz.name}
                                            </p>
                                        </div>
                                    </Dropdown.Item>
                                ))}
                            </div>
                        </Dropdown.Menu>
                    </Dropdown>
                ) : (
                    <div className="spinner-border spinner-border-sm text-brand ms-2" role="status"></div>
                )}
            </div>

            <div className="d-flex align-items-center gap-2 gap-md-3">
                {/* <div className="p-2 rounded hover-effect cursor-pointer text-muted relative">
                    <LuBell size={20} />
                    <span className="position-absolute top-1 start-1 translate-middle badge rounded-pill bg-danger" style={{ fontSize: '10px', padding: '3px 5px' }}>
                        12
                    </span>
                </div> */}

                <Dropdown align="end">
                    <Dropdown.Toggle as="div" className="d-flex align-items-center gap-2 cursor-pointer no-caret">
                        <div className="text-end d-none d-md-block">
                            <p className="mb-0 fw-bold lh-1" style={{ fontSize: '13px' }}>{userDetail?.fullName || "Admin"}</p>
                            <small className="text-muted" style={{ fontSize: '11px' }}>Master Admin</small>
                        </div>
                        <div className="bg-light p-2 rounded-circle text-brand border shadow-sm">
                            <LuUserRound size={22} />
                        </div>
                    </Dropdown.Toggle>

                    <Dropdown.Menu className="border-0 shadow-lg mt-2" style={{ borderRadius: '12px', minWidth: '200px' }}>
                        <Dropdown.Item onClick={() => navigate('/profile')} className="py-2 d-flex align-items-center gap-2">
                            <LuUser size={16} /> Profile
                        </Dropdown.Item>
                        {/* <Dropdown.Item onClick={() => navigate('/settings')} className="py-2 d-flex align-items-center gap-2 border-bottom">
                            <LuSettings size={16} /> settings
                        </Dropdown.Item> */}
                        <Dropdown.Item onClick={handleLogout} className="py-2 d-flex align-items-center gap-2 text-danger">
                            <LuLogOut size={16} /> Logout
                        </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </div>
            <ConfirmModal
                show={showLogoutModal}
                onHide={() => setShowLogoutModal(false)}
                onConfirm={confirmLogout}
                title="Confirm Logout"
                message="Are you sure you want to end your session? You will need to login again to manage your businesses."
                confirmText="Yes, Logout"
                variant="danger"
                icon={LuLogOut}
            />
        </header>
    );
};

export default Header;
